<template>
  <el-dialog
    title="重命名网点"
    v-model="dialogVisible"
    width="400px"
    @close="handleCancel"
  >
    <div class="dialog-content">
      <el-form :model="formData" label-position="top">
        <el-form-item label="新网点名称" prop="site">
          <el-input
            v-model="formData.site"
            placeholder="请输入新的网点名称"
          />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '确定' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { postWlApi } from '@utils/api_v1.js'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  accessId: {
    type: Number,
    required: true
  },
  currentSite: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close', 'success'])

const formData = reactive({
  site: ''
})

const submitting = ref(false)
const dialogVisible = ref(props.visible)

// 监听visible属性变化，控制对话框显示
watch(() => props.visible, (newVal) => {
  dialogVisible.value = newVal
  if (newVal) {
    formData.site = props.currentSite
  }
})

// 监听dialogVisible变化，当对话框关闭时触发close事件
watch(dialogVisible, (newVal) => {
  if (!newVal) {
    resetState()
    emit('close')
  }
})

const resetState = () => {
  formData.site = ''
  submitting.value = false
}

const handleCancel = () => {
  dialogVisible.value = false
}

const handleSubmit = async () => {
  if (!formData.site.trim()) {
    ElMessage.error('请输入网点名称')
    return
  }

  submitting.value = true

  try {
    const requestData = {
      access_id: props.accessId,
      site: formData.site.trim()
    }

    const response = await postWlApi('/rename_site', requestData)

    if (response.code === 0) {
      ElMessage.success('网点重命名成功')
      emit('success')
    } else {
      ElMessage.error(response.message || '网点重命名失败')
    }
  } catch (error) {
    console.error('重命名网点失败:', error)
    ElMessage.error('网点重命名失败')
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.dialog-content {
  padding: 0;
}
</style>
